export const SUBSCRIPTION_DOCUMENT_TYPES = [
  {
    text: 'Contract',
    value: '20',
  },
  {
    text: 'Lease Contract',
    value: '34',
  },
  {
    text: 'Return form',
    value: '35',
  },
  {
    text: 'Invoice',
    value: '14',
  },
  {
    text: 'Authorization',
    value: '22',
  },
  {
    text: 'Other',
    value: '27',
  },
];

export const ACCEPT_DOCUMENTS = {
  'image/png': ['.png'],
  'image/jpg': ['.jpg'],
  'image/jpeg': ['.jpeg'],
  'application/pdf': ['.pdf'],
};
